export enum Direction {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type Sort<T> = {
    by: keyof T;
    direction: Direction;
};

export const toggleSort = <T, >(newBy: keyof T, currentSort: Sort<T> | null): Sort<T> => {
    if (!currentSort) {
        return {
            by: newBy,
            direction: Direction.DESC,
        };
    }

    return {
        by: newBy,
        direction: newBy === currentSort.by ?
            (currentSort.direction === Direction.ASC ? Direction.DESC : Direction.ASC) : Direction.DESC,
    };
}

